import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { ShipmentManifestLink } from '../../core/api/lab.types';

export const getShipmentManifestHasErrorSelector = (state: RootState): boolean =>
  state.getShipmentManifest.errors && state.getShipmentManifest.errors ? true : false;

export const getShipmentManifestIsBusySelector = (state: RootState): boolean =>
  state.getShipmentManifest.status === StoreStatus.BUSY;

export const getShipmentManifestResponseSelector = (state: RootState): ShipmentManifestLink | null =>
  state.getShipmentManifest.response || null;
